import { z } from 'zod';
import { CompetitorDaysData, OtherPrices, PmcPriceMode, PriceOption, SetupIPADadosDeConcorrencia } from '../SetupIPADadosDeConcorrenciatypes';

export interface ConfigFormProps {
  data?: SetupIPADadosDeConcorrencia;
  createConfig: (data: CompetitorDaysData) => Promise<SetupIPADadosDeConcorrencia>;
  updateConfig: (data: CompetitorDaysData) => Promise<SetupIPADadosDeConcorrencia>;
  isLoading?: boolean;
  isSaving?: boolean;
}

const percentageSchema = z.number().nullable();

export const schema = z
  .object({
    id: z.string().nullable().optional(),
    competitor_days: z.coerce.number().min(1, 'Deve ser maior que 0').max(180, 'Deve ser menor que 180'),
    suppliers_competitor_days: z.coerce.number().min(1, 'Deve ser maior que 0').max(180, 'Deve ser menor que 180'),
    price_option: z.nativeEnum(PriceOption),
    other_prices: z.array(z.nativeEnum(OtherPrices)),
    pmc_price_mode: z.nativeEnum(PmcPriceMode),
    outlier_config: z.object({
      active: z.boolean(),
      max_limit: percentageSchema,
      min_limit: percentageSchema,
    }),
  })
  .superRefine(({ outlier_config }, context) => {
    if (!outlier_config.active) return;

    const validatePercentage = (value: number | null, path: 'max_limit' | 'min_limit') => {
      if (value === null || value <= 0) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Informe um valor maior que 0',
          path: ['outlier_config', path],
        });
        return;
      }

      if (!Number.isInteger(value * 10)) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Informe no máximo uma casa decimal',
          path: ['outlier_config', path],
        });
      }
    };

    validatePercentage(outlier_config.max_limit, 'max_limit');
    validatePercentage(outlier_config.min_limit, 'min_limit');
  });

export type FormValues = z.infer<typeof schema>;
